export const isProd = true;
export const WEB_SERVICE_URL = isProd === true ? "https://api.cookiesuit.com/admin/":"http://localhost:5000/admin/";
export const ASSETS = "/assets/";
export const CDNURL = 'https://cdn.cookiesuit.com/sdk/cookie-bundle.js?key=';

